// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Bo-E","alertIcon":"ConfirmModal_alertIcon__CUwnH"};